import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CMSPageDetailsDTO, CMSPageListDTO, UpdatePageCommandDTO } from './models';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor(private _http: HttpClient, @Inject('API_URL') private _apiUrl: string, private http: HttpClient) { }

  getPagesByCategory(categoryId: number): Observable<CMSPageListDTO[]> {
    return this.http.get<CMSPageListDTO[]>(`${this._apiUrl}/cms/pages/by-category/${categoryId}`);
  }

  updatePage(page: UpdatePageCommandDTO): Observable<void> {
    return this.http.put<void>(`${this._apiUrl}/cms/pages/${page.pageId}`, page);
  }

  getPageById(id: number): Observable<CMSPageDetailsDTO> {
    return this.http.get<CMSPageDetailsDTO>(`${this._apiUrl}/cms/pages/${id}`);
  }

}
